// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2MUaz","content":"LoadingAlert_content__25yqZ"};